import { Component } from '@angular/core';

import { LayoutConfig, LayoutPrivileges } from '@layout/layout.abstract.config';

@Component({
  selector: 'mojo-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss'],
})
export class AddButtonComponent {
  privileges: LayoutPrivileges;

  constructor(layoutConfig: LayoutConfig) {
    this.privileges = layoutConfig.privileges;
  }
}
